  import {
      Flex,
      Box,
      FormControl,
      FormLabel,
      Input,
      InputGroup,
      HStack,
      InputRightElement,
      Stack,
      Button,
      Heading,
      Text,
      useColorModeValue,
      Link,
      FormHelperText,
    } from '@chakra-ui/react';
    import { useState } from 'react';
    import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

    import Swal from 'sweetalert2'
    import { useNavigate } from 'react-router-dom'
    
    export default function Signup() {

      const navigate = useNavigate()
      const [showPassword, setShowPassword] = useState(false);
      const [name, setName] = useState("")
      const [username, setUsername] = useState("")
      const [email, setEmail] = useState("")
      const [phoneNumber, setPhoneNumber] = useState("")
      const [password, setPassword] = useState("")

      const handleSubmit = async (e) => {
        e.preventDefault();
        const options = {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            username: username,
            email: email,
            phone_number: phoneNumber,
            password: password 
          })
        }
        const request = await fetch("https://expensewebproject.herokuapp.com/auth/signup/", options);
        const response = await request.json()
        Swal.fire(
          'Account Registered Successfully',
        )
        navigate('/login')
        return response;
      }
    
      return (
        <Flex
          minH={'100vh'}
          align={'center'}
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <Stack align={'center'}>
              <Heading fontSize={'4xl'} textAlign={'center'}>
                Sign up
              </Heading>
              <Text fontSize={'lg'} color={'gray.600'}>
                to start tracking your expenses ✌️
              </Text>
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
            <form onSubmit={handleSubmit} method="post">
              <Stack spacing={4}>
                <HStack>
                <Box>
                    <FormControl id="name" name="name" >
                      <FormLabel>Name</FormLabel>
                      <Input type="text" value={name} onChange={(e) => (setName(e.target.value))}/>
                    </FormControl>
                  </Box>
                  <Box>
                    <FormControl id="username" isRequired>
                      <FormLabel>Username</FormLabel>
                      <Input type="text" value={username} onChange={(e) => (setUsername(e.target.value))}/>
                    </FormControl>
                  </Box>
                </HStack>
                <FormControl id="email" isRequired>
                  <FormLabel>Email address</FormLabel>
                  <Input type="email" value={email} onChange={(e) => (setEmail(e.target.value))}/>
                </FormControl>
                <FormControl id="phone_number" isRequired>
                  <FormLabel>Phone Number</FormLabel>
                  <Input type='tel' value={phoneNumber} onChange={(e) => (setPhoneNumber(e.target.value))}/>
                  <FormHelperText fontWeight={'600'} mb={2}>Include your country code</FormHelperText>
                </FormControl>
                <FormControl id="password" isRequired>
                  <FormLabel>Password</FormLabel>
                  <InputGroup>
                    <Input type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => (setPassword(e.target.value))}/>
                    <InputRightElement h={'full'}>
                      <Button
                        variant={'ghost'}
                        onClick={() =>
                          setShowPassword((showPassword) => !showPassword)
                        }>
                        {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <Stack spacing={10} pt={2}>
                  <Button
                    loadingText="Submitting"
                    size="lg"
                    bg={'blue.400'}
                    color={'white'}
                    type={"submit"}
                    _hover={{
                      bg: 'blue.500',
                    }}>
                    Sign up
                  </Button>
                </Stack>
                <Stack pt={6}>
                  <Text align={'center'}>
                    Already a user? <Link color={'blue.400'} href={'/login'}>Login</Link>
                  </Text>
                </Stack>
              </Stack>
              </form>
            </Box>
          </Stack>
        </Flex>
      );
    }